import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import qs from 'query-string';
import PropTypes from 'prop-types'
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import CustomDatePicker from '../common/CustomDatePicker';
import { isJsonParsable, shouldDisableDate } from '../../helpers';
import './DatePickerWrapperComponent.sass';

const DatePickerWrapperComponent = (props) => {

  const { t } = useTranslation();
  const { filterKey, dateFilter, tableName } = props;
  const restrictPastdateFeilds = new Set(['onTimeDelivery', 'onTimePickup']);
  const [searchParams, setSearchParams] = useSearchParams();
  const [startTime, setStartDate] = React.useState(null);
  const [endTime, setEndDate] = React.useState(null);
  const [search, setSearch] = React.useState(() => Object.fromEntries([...searchParams]));

  useEffect(() => {
    const params = Object.fromEntries([...searchParams]);
    setSearch(params);
    const tempValues = isJsonParsable(params[filterKey]) || {};
    setStartDate(tempValues.startTime);
    setEndDate(tempValues.endTime);
  }, [searchParams, filterKey]);

  const isDateValid = (dateStr) => {
    if (!restrictPastdateFeilds.has(tableName)) {
      return true;
    }
    if (!dateStr) return true;
    const selectedDate = moment(dateStr, "YYYY-MM-DD").toDate();
    return !shouldDisableDate(selectedDate);
  };

  const canUpdateSearchParams = (newStartTime, newEndTime) => {
    if (!restrictPastdateFeilds.has(tableName)) {
      return true;
    }
    return isDateValid(newStartTime) && isDateValid(newEndTime);
  };

  const handleStartDate = (newValue) => {
    let date = null;
    date = dateFilter.dummytime && moment(newValue, "YYYY-MM-DD").format(`YYYY-MM-DD ${dateFilter.startTime}`)
    setStartDate(date);

    if (date && endTime && canUpdateSearchParams(date, endTime)) {
      setSearchParams(qs.stringify({
        ...search,
        [filterKey]: JSON.stringify({ startTime: date, endTime })
      }))
    }
  };

  const handleEndDate = (newValue) => {
    let date = null;
    date = dateFilter.dummytime && moment(newValue, "YYYY-MM-DD").format(`YYYY-MM-DD ${dateFilter.endTime}`)
    setEndDate(date);

    if (date && startTime && canUpdateSearchParams(startTime, date)) {
      setSearchParams(qs.stringify({
        ...search,
        [filterKey]: JSON.stringify({ startTime, endTime: date })
      }))
    }
  }

  return (
    <>
      <div className='containerBox'>
        <CustomDatePicker
          label={t('start_date')}
          onChange={handleStartDate}
          value={startTime}
          maxDate={endTime}
          disablePastDates={restrictPastdateFeilds.has(tableName)}
        />
        <Typography variant="h5" className="text">{t('to')}</Typography>
        <CustomDatePicker
          value={endTime}
          onChange={handleEndDate}
          label={t('end_date')}
          minDate={startTime}
          disablePastDates={restrictPastdateFeilds.has(tableName)}
        />
      </div>
      {restrictPastdateFeilds.has(tableName) && <Typography variant='body2' className='message'>{t('error_date_older_than_one_year')}</Typography>}
    </>
  )
}

DatePickerWrapperComponent.propTypes = {
  filterKey: PropTypes.string.isRequired,
  dateFilter: PropTypes.shape({
    dummytime: PropTypes.bool,
    startTime: PropTypes.string,
    endTime: PropTypes.string
  }).isRequired,
  tableName: PropTypes.string.isRequired
};

export default DatePickerWrapperComponent